import { useNavigate, useSearchParams } from "react-router";
import ScrollToTop from "../../widgets/utils";
import { DestinationCard } from "../destination_cards";
import { TourMap } from "../map";
import { TourCard } from "./tour_card";
import { useContext, useEffect, useState } from "react";
import { State, StateContext } from "../../state";
import { Footer } from "../footer";
import { Button, IconButton, Typography } from "@mui/material";
import { ArrowBackIos, ArrowForwardIos, LocationOn } from "@mui/icons-material";
import { filterFor, filterForDestinationId, SearchBar } from "../searchbar";
import { T } from "../../i18n";
import { mobile, tourDistance } from "../../utils/utils.";
import { TrackService } from "../../client";
import _ from "lodash";

const NEXT_PAGE_SIZE = 20;

const fakeTours = [{}, {}, {}, {}, {}, {} , {} , {}]

const maxLength = 8;

export const TrackList = ({full, mode}: any) => {
    const { myPos, tours, destinations, loadMoreTours, hasMoreTours, loadingMore } = useContext(StateContext) as State;
    const extra = window.location.href.startsWith("http://localhost:3000/") ? 48: 1
    const [maxDistanceToBeClosedToMe, setMaxDistanceToBeClosedToMe] = useState(1000 * 200 * extra ) // default 200km
    const [searchText, setSearchText] = useState<string>("");

    const [destinationId, setDestinationId] = useState<any>()
    const [bgLoaded, setBgLoaded] = useState(false);
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    // Nella lista full, ricerca e filtro per destinazione vengono caricati dal
    // server (non più filtrando la cache client). remoteTours === null = lista
    // normale paginata dalla cache di stato; altrimenti risultati remoti.
    const [remoteTours, setRemoteTours] = useState<any[] | null>(null);
    const [remoteMode, setRemoteMode] = useState<'none' | 'search' | 'destination'>('none');
    const [remotePage, setRemotePage] = useState(0);
    const [remoteHasMore, setRemoteHasMore] = useState(false);
    const [remoteLoading, setRemoteLoading] = useState(false);

    useEffect(() => {
      if (!full) { setRemoteTours(null); setRemoteMode('none'); return; }
      let alive = true;
      if (searchText) {
        // Ricerca tour lato server (top 20, senza paginazione).
        setRemoteMode('search'); setRemoteLoading(true); setRemoteHasMore(false);
        TrackService.search(searchText)
          .then((r: any) => { if (alive) { setRemoteTours(r || []); setRemoteLoading(false); } })
          .catch(() => { if (alive) { setRemoteTours([]); setRemoteLoading(false); } });
      } else if (destinationId) {
        // Lista filtrata per destinazione lato server (paginata).
        setRemoteMode('destination'); setRemoteLoading(true); setRemotePage(0);
        TrackService.list(0, destinationId)
          .then((r: any) => { if (alive) { setRemoteTours(r || []); setRemoteHasMore((r || []).length >= 70); setRemoteLoading(false); } })
          .catch(() => { if (alive) { setRemoteTours([]); setRemoteHasMore(false); setRemoteLoading(false); } });
      } else {
        setRemoteMode('none'); setRemoteTours(null);
      }
      return () => { alive = false; };
    }, [full, searchText, destinationId]);

    const loadMoreDestination = () => {
      if (remoteLoading || !remoteHasMore) return;
      const next = remotePage + 1;
      setRemoteLoading(true);
      TrackService.list(next, destinationId)
        .then((r: any) => {
          setRemoteTours(prev => {
            const ex = new Set((prev || []).map((t: any) => t.id));
            return [...(prev || []), ...(r || []).filter((t: any) => !ex.has(t.id))];
          });
          setRemotePage(next);
          if ((r || []).length < NEXT_PAGE_SIZE) setRemoteHasMore(false);
          setRemoteLoading(false);
        })
        .catch(() => setRemoteLoading(false));
    };

    const isWeb = window.innerWidth > 600;
    const lowImg = isWeb ? require('../images/bg_acqua2_lq.jpg') : require('../images/bg_acqua1_lq.jpg');
    const fullImg = isWeb ? require('../images/bg_acqua2.jpg') : require('../images/bg_acqua1.jpg');

    useEffect(() => {
      const img = new Image();
      img.onload = () => setBgLoaded(true);
      img.src = fullImg;
    }, [fullImg]);
    
    useEffect(() => {
      if (searchParams.get("destination")) {
        const sd = Number(searchParams.get("destination"))
        const dest = destinations.find((d:any) => d.id === sd)
        if(dest) {
          setDestinationId(dest.id)
        }
      } else {
        setDestinationId(undefined)
      }
      const query = searchParams.get("q");
      if(query) {
        setSearchText(decodeURIComponent(query))
      } else {
        setSearchText("")
      }


      const limit = window.innerWidth <= 600 ? 100 : 500
      const isHome = document.querySelector('.jumbo')
      const cont: any = document.querySelector('.header .searchbar-main')
      const header: any = document.querySelector('.header')
      if(isHome && cont && !(document.body.scrollTop > 200 || document.documentElement.scrollTop > 200)) {
        cont.style.display = "none"
        if(mobile && header && isHome) {
          header.classList.add('header-transparent')
        }
      } else {
        if (mobile && header && isHome) {
          header.classList.remove('header-transparent')
        }
      }

      window.onscroll = () => {
        const div = document.getElementById("jumbo");
        if(div) {
          // if (document.body.scrollTop > 5 || document.documentElement.scrollTop > 5) {
          //   div.style.height = window.innerWidth >= 600 ? "300px" : "280px";
          // } else {
          //   div.style.height = window.innerWidth >= 600 ? "600px" : "400px";
          // }
          const cont: any = document.querySelector('.header .searchbar-main')
          if(!isHome && cont) {
            cont.style.display = "flex"
          } else {
            if ((document.body.scrollTop > limit || document.documentElement.scrollTop > limit) && cont) {
              cont.style.display = "flex"
              if(mobile && header) {
                header.classList.remove('header-transparent')
              }
            } else {
              cont.style.display = "none"
              if(mobile && header) {
                header.classList.add('header-transparent')
              }
            }
          }
        }
      };
      
      return () => {
        header.classList.remove('header-transparent')
      }
    }, [searchParams])

    let _tours = [...tours];
    if (full && remoteTours !== null) {
      // Lista full con ricerca o destinazione: risultati dal server.
      _tours = remoteTours;
    } else {
      if(searchText) {
        _tours = filterFor(tours, searchText);
      }
      if(destinationId) {
        _tours = filterForDestinationId(_tours, destinationId)
      }
    }

    let _close_tours:any = [];
    if(myPos) {
      _tours.forEach((t: any) => {
        t.distance = tourDistance(t.routes[0].track, [myPos.latitude, myPos.longitude])
      })
      _close_tours = _tours.filter((t: any) => {
        return t.distance <= maxDistanceToBeClosedToMe
      });
      _close_tours = _.sortBy(_close_tours, 'distance')
    }
      if(!full) {
      _close_tours = _close_tours.slice(0, maxLength)
    }
    if(!full) {
      _tours = _tours.filter((t:any) => _close_tours.length === 0 || !_close_tours.find((tt:any) => tt.id === t.id))
      _tours = _tours.splice(0, maxLength)
    }
    
    if (mode === 'map' && full) {
      return (
        <>
          <ScrollToTop />
          <TourMap tours={_tours} me={myPos} />
        </>
      )
    }

    if (full) {
      let listTitle = (destinationId ? `${T('tours_in')} ${searchParams.get("dN")}` : T("bike_tours_title"))
      if(searchText) {
        listTitle =  `${T('search_results_for')} "${searchText}"`
      }
      return (
        <>
          <ScrollToTop />
          <div className="container">
            <div className="pad-20 relative">
              <IconButton
                onClick={() => navigate('../map', {state: {firstTour: (searchText || destinationId) ? _tours[0]: undefined}})}
                style={{color: "white", position: "absolute", right: '20px', top: '20px', zIndex: 10, background: "#1b76d3", borderRadius: '16px', fontSize: mobile ? 18: 22}}
              >
                <LocationOn />
                {T('Mappa')}
              </IconButton>
              <div className="xs-350-container">
                <div className="xs-350">
                  <HorizontalCarousel 
                    cardReactElement={TourCard}
                    className="row-wrap gap-40 card-fullwidth"
                    paramName="tour"
                    titleClass="section-title xs-60"
                    searchText={searchText}
                    destinationId={destinationId}
                    title={listTitle}
                    tourList={_tours}
                  />
                </div>
              </div>
              {(() => {
                // Pulsante "Carica altri tour":
                // - lista normale -> pagina successiva dalla cache di stato
                // - lista per destinazione -> pagina successiva dal server
                // - ricerca -> nessun pulsante (già limitata a 20 risultati)
                const showMain = remoteMode === 'none' && hasMoreTours;
                const showDest = remoteMode === 'destination' && remoteHasMore;
                if (!showMain && !showDest) return null;
                const isLoading = remoteMode === 'destination' ? remoteLoading : loadingMore;
                const onLoad = remoteMode === 'destination' ? loadMoreDestination : loadMoreTours;
                return (
                  <div className="show-all-tours" style={{ textAlign: 'center', marginTop: 20 }}>
                    <Button variant="contained" className="search-btn" disabled={isLoading} onClick={onLoad}>
                      {isLoading ? `${T('loading')}…` : T('load_more_tours')}
                    </Button>
                  </div>
                );
              })()}
            </div>
          </div>
        </>
      )
    }

    return (
      <>
        <div className="jumbo" style={{backgroundImage: `url(${lowImg})`, backgroundPosition: "center 47%"}} id="jumbo">
          <div
            className="jumbo-hires"
            style={{
              backgroundImage: `url(${fullImg})`,
              backgroundPosition: "center 47%",
              opacity: bgLoaded ? 1 : 0,
            }}
          />
          <SearchBar hideOnScroll />
            <div className="container relative">
              <div className="jumbo-text">
                {!mobile && <Typography variant="h3" className="title" sx={{marginBottom: "10px"}}>{T("jumbo_title")}</Typography>}
                <Typography variant="h5" className="subtitle">{T("jumbo_subtitle")}</Typography>
              </div>
            </div>
        </div>
        <div className="container" id="tour_section">
          <div className="pad-20-0">
                {_close_tours.length > 0 && !destinationId &&
                  <HorizontalCarousel
                    cardReactElement={TourCard} 
                    paramName={"tour"} 
                    title={T("close_title")}
                    tourList={_close_tours}
                    titleClass="section-title"
                    className={full ? "row-wrap gap-40 card-fullwidth" : "row-wrap gap-40-20 horizontal-scroll"}
                    full={full}
                    oneline
                    // showMap
                  />
                }
                {((_close_tours.length > 0 && _tours.length > 0) || (_close_tours.length === 0)) &&
                  <HorizontalCarousel
                    cardReactElement={TourCard}
                    paramName={"tour"}
                    title={T("bike_tours_title")}
                    tourList={_tours}
                    showAll
                    full={full}
                    className={full ? "row-wrap gap-40 card-fullwidth" : "row-wrap gap-40-20 horizontal-scroll"}
                  />
                }
                <HorizontalCarousel
                  cardReactElement={DestinationCard} 
                  paramName={"destination"}
                  title={T('favourite_locations')}
                  tourList={destinations}
                  className={full ? "row-wrap gap-40 card-fullwidth" : "row-wrap gap-40-20 horizontal-scroll"}
                  full={full}
                  oneline
                  onClick={(d: any) => navigate(`/list?destination=${d.id}&dN=${d.name}`)}
                />
          </div>
        </div>
        <Footer />
      </>
    )
  }

export const HorizontalCarousel = (
  {
    cardReactElement, paramName, title, showMap,
    tourList, destinationId, className, hideEmpty,
    showAll, full,
    searchText, oneline, titleClass, minToShow, onClick
  }:any) => {

  const [Forward, setForward] = useState<boolean>(true);
  const [Back, setBack] = useState<boolean>(false);
  const [clickedIndex, setClicked] = useState<any>(false);

  const navigate = useNavigate()

  const onScrollHandler = (e: any) => {
    const div = e.target;
    const end = (div.scrollWidth - div.clientWidth - 10);
    const start = 10
    const x = div.scrollLeft
    if(x > start && x < end && !Forward) {
      setForward(true)
    }
    if(x >= end && Forward === true) {
      setForward(false)
    }

    if(x <= end  && x > start && !Back) {
      setBack(true)
    }
    if((x <= start) && Back === true) {
      setBack(false)
    }
  }
  
  const scrollLeft = (idTitle: string) => {
    const el = document.getElementById(idTitle)
    if(el) {
      const right = el.scrollLeft + window.innerWidth
      el.scrollTo({ left: right, behavior: "smooth"})
    }
  }

  const scrollRight = (idTitle: string) => {
    const el = document.getElementById(idTitle)
    if(el) {
      const left = el.scrollLeft - window.innerWidth < 0 ? 0 : el.scrollLeft - window.innerWidth
      el.scrollTo({ left: left, behavior: "smooth"})
    }
  }

  let _minToShow = minToShow ? minToShow : 4
  const toShow = tourList.length > _minToShow;
  let cont = className
  if(oneline) {
    cont += " force-horizontal-scroll"
  }
  const idTitle = title.replaceAll(" ", "_")
  let _titleClass = titleClass ? titleClass : 'section-title'
  if(showMap) {
    _titleClass += " xs-60"
  }

  if(hideEmpty && tourList.length === 0 && !searchText && (!destinationId)) {
    return <></>
  }

  return (
    <div className="relative">
      <div className="row gap-20 fsb">
        <div className={_titleClass}
          style={{ marginTop: 0}}
          >
          {title}
        </div>
        {showMap &&
          <IconButton
          onClick={() => navigate('../map')}
          style={{color: "white", background: "#1b76d3", borderRadius: '16px', fontSize: mobile ? 18: 22, marginRight: "20px"}}
          >
            <LocationOn />
            {T('Mappa')}
          </IconButton>
        }
      </div>
      <br/>
      {oneline && toShow && Forward &&
        <div className="scroll-arrow scroll-arrow-left" onClick={() => scrollLeft(idTitle)}>
          <ArrowForwardIos/>
        </div>
      }
        {oneline && toShow && Back &&
        <div className="scroll-arrow scroll-arrow-right" onClick={() => scrollRight(idTitle)}>
          <ArrowBackIos sx={{ marginLeft: "4px", marginRight: "-4px"}}/>
        </div>
      }
      <div className={cont} id={idTitle} onScroll={onScrollHandler}>
      {tourList
          .map((t:any, index: number) => {
            const CardComp = cardReactElement;
            return (
            <div className="card-container" key={t.id ?? index}>
              <CardComp {...{[paramName]: t, onClick, clicked: clickedIndex === index, setClicked, index}} />
            </div>
          )})}
        {tourList.length === 0 && (searchText) &&
          <p>{T('no_tours_found')} "{searchText}"</p>
        }
        {tourList.length === 0 && !searchText && (!destinationId) &&
          fakeTours
          .map(t => (
            <div className="card-container">
              <TourCard tour={t} fake={true} />
            </div>
        ))
        }
      </div>
      <br/><br/>
      {showAll && !full && tourList.length > 0 &&
        <div className="show-all-tours">
          <span onClick={() => navigate('/list')}>
            {T("show_all_tours")}
            <ArrowForwardIos className="show-all-arrow" />
          </span>
        </div>
      }
    </div>
  )
}